import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const siteName = 'Sanjeevi Grace Herbals';
const siteUrl = (process.env.REACT_APP_SITE_URL || '').replace(/\/$/, '');
const metadata = {
  '/': ['Traditional Siddha and Herbal Wellness', 'Explore the Sanjeevi Grace Herbals product catalogue and customer support services.'],
  '/shop': ['Shop Herbal Products', 'Browse the Sanjeevi Grace Herbals product catalogue by product form and category.'],
  '/categories': ['Product Categories', 'Explore the Sanjeevi Grace Herbals catalogue by product category.'],
  '/wellness': ['Wellness Concerns', 'Browse available products by wellness concern.'],
  '/about': ['About Us', 'Learn about Sanjeevi Grace Herbals and its approach to traditional herbal wellness.'],
  '/contact': ['Contact Us', 'Contact Sanjeevi Grace Herbals customer support.'],
  '/medical-disclaimer': ['Medical Disclaimer', 'Read the medical information disclaimer for this website.'],
  '/shipping-policy': ['Shipping Policy', 'Read the shipping information for Sanjeevi Grace Herbals orders.'],
  '/cancellation-policy': ['Cancellation Policy', 'Read the order cancellation information.'],
  '/return-refund-policy': ['Return and Refund Policy', 'Read the return and refund information.'],
  '/privacy': ['Privacy Policy', 'Read how website and account information is handled.'],
  '/terms': ['Terms and Conditions', 'Read the website terms and conditions.']
};

function upsertMeta(name, content) {
  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!element) { element = document.createElement('meta'); element.setAttribute('name', name); document.head.appendChild(element); }
  element.setAttribute('content', content);
}

function upsertProperty(property, content) {
  let element = document.head.querySelector(`meta[property="${property}"]`);
  if (!content) { element?.remove(); return; }
  if (!element) { element = document.createElement('meta'); element.setAttribute('property', property); document.head.appendChild(element); }
  element.setAttribute('content', content);
}

function upsertNamedMeta(name, content) {
  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!content) { element?.remove(); return; }
  if (!element) { element = document.createElement('meta'); element.setAttribute('name', name); document.head.appendChild(element); }
  element.setAttribute('content', content);
}

function upsertCanonical(href) {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!href) { element?.remove(); return; }
  if (!element) { element = document.createElement('link'); element.setAttribute('rel', 'canonical'); document.head.appendChild(element); }
  element.setAttribute('href', href);
}

export default function RouteMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    const productRoute = pathname.startsWith('/products/');
    const [title, description] = metadata[pathname] || (productRoute
      ? ['Product Details', 'View product information and current online availability.']
      : [siteName, 'Sanjeevi Grace Herbals customer website.']);
    const privateRoute = /^\/(login|register|forgot-password|verification-pending|account|orders|checkout|order-confirmation|admin|track-order|search|cart|wishlist|403|500|maintenance)(\/|$)/.test(pathname);
    const fullTitle = title === siteName ? siteName : `${title} | ${siteName}`;
    const canonical = !privateRoute && siteUrl ? `${siteUrl}${pathname === '/' ? '' : pathname}` : '';

    document.title = fullTitle;
    upsertMeta('description', description);
    upsertMeta('robots', privateRoute ? 'noindex,nofollow' : 'index,follow');
    upsertProperty('og:title', fullTitle);
    upsertProperty('og:description', description);
    upsertProperty('og:type', productRoute ? 'product' : 'website');
    upsertProperty('og:url', canonical);
    upsertProperty('og:image', siteUrl ? `${siteUrl}/assets/logo/logo.jpeg` : '');
    upsertNamedMeta('twitter:card', 'summary');
    upsertNamedMeta('twitter:title', fullTitle);
    upsertNamedMeta('twitter:description', description);
    upsertNamedMeta('twitter:image', siteUrl ? `${siteUrl}/assets/logo/logo.jpeg` : '');
    upsertCanonical(canonical);
  }, [pathname]);

  return null;
}
